


















import { Component, Watch } from "vue-property-decorator";
import { BaseOperationPropertyVue } from "fs-pb-vue2/vueModels/operations/properies/BaseOperationPropertyVue";
import { OperationsApi } from "fs-pb-vue2/services/api/OperationsApi";

@Component({})
export default class AcceptProperty extends BaseOperationPropertyVue {

  @Watch('property.Value', { immediate: true })
  valueChanged(val: string): void {
    const valToArr: Array<any> = val.split('#');
    this.links = [];

    if (valToArr.length > 0) {
      this.booleanValue = valToArr[0];
      this.links.push(valToArr[1]);
      this.links.push(valToArr[2]);
    }

    this.modelValue = this.booleanValue === '1' ? true : false;
  }

  @Watch('modelValue', { immediate: true })
  modelChanged(val: boolean): void {
    if (val)
      this.property.Value = '1' + this.property.Value.substring(1);
    else
      this.property.Value = '0' + this.property.Value.substring(1);
  }

  get acceptCaption(): string {
    let result: string = this.caption;

    this.links.map((link: any, index: number) => {
      result = result.replaceAll(`href="${index}"`, `v-bind:click="openConditions($event)" id="accept-rule-${index}"`)
    })

    return result;
  }

  booleanValue: string = '0';

  modelValue: boolean = false;

  links: Array<string> = [];

  async openConditions(e: any): Promise<void> {
    let id: number = 0;
    if (e.target.getAttribute('id') === 'accept-rule-0' || e.target.getAttribute('id') === 'accept-rule-1')
      id = +e.target.getAttribute('id').substring(e.target.getAttribute('id').length-1);
    else
      return;

    const valToArr: Array<string> = this.links[id].split('|');
    switch (valToArr[0]) {
      case "OB":
        window.open(valToArr[1], "_blank");
        break;
      case "SF": {
        window.open(valToArr[1], "_blank");
        break;
      }
      case "SDF":{
        await OperationsApi.getDocumentFileData(+valToArr[1], valToArr[2]);
        break;
      }
      default:
        break;
    }
  }

}
